var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49987 11.7V11.2H7.49987V11.7H8.49987ZM7.49987 11.7107V12.2107H8.49987V11.7107H7.49987ZM7.49987 4.76666V9.03332H8.49987V4.76666H7.49987ZM7.49987 11.7V11.7107H8.49987V11.7H7.49987ZM7.99987 15.4667C4.15229 15.4667 1.0332 12.3476 1.0332 8.49999H0.0332031C0.0332031 12.8999 3.6 16.4667 7.99987 16.4667V15.4667ZM14.9665 8.49999C14.9665 12.3476 11.8475 15.4667 7.99987 15.4667V16.4667C12.3997 16.4667 15.9665 12.8999 15.9665 8.49999H14.9665ZM7.99987 1.53333C11.8475 1.53333 14.9665 4.65241 14.9665 8.49999H15.9665C15.9665 4.10012 12.3997 0.533325 7.99987 0.533325V1.53333ZM7.99987 0.533325C3.6 0.533325 0.0332031 4.10012 0.0332031 8.49999H1.0332C1.0332 4.65241 4.15229 1.53333 7.99987 1.53333V0.533325Z",
    fill: "#808191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.05a7d20fabbcaa018217289cbc72b0a7.svg";
export { ForwardRef as ReactComponent };